// @flow

import * as React from 'react';
import type { Node } from 'react';
import Title from 'components/Title';

import './style.scss';

type Props = {
  title: string,
  subtitle?: string,
  children: Node,
  ilustration?: any,
  ctaButton?: Node,
};

export default function Basic(props: Props): Node {
  const { title, subtitle, children, ilustration, ctaButton } = props;
  return (
    <div className="BasicLayout">
      <header className="BasicLayout__header">
        <div className="BasicLayout__headerContent">
          <Title tag="h1" fontSize="l">
            {title}
          </Title>
          {subtitle && (
            <Title tag="p" fontSize="m">
              {subtitle}
            </Title>
          )}
          {ctaButton && (
            <div className="BasicLayout__ctaButton">{ctaButton}</div>
          )}
        </div>
        {ilustration && (
          <div className="BasicLayout__ilustration">{ilustration}</div>
        )}
      </header>
      <main className="BasicLayout__content">{children}</main>
    </div>
  );
}
Basic.defaultProps = {
  subtitle: '',
  ilustration: null,
  ctaButton: null,
};
